import { PropType, ExtractPropTypes } from 'vue'
import { Required } from 'utility-types'
import type { SelectProps } from 'ant-design-vue/es/select'
// type SelectorTypes = keyof Reference.SelectorTypes

export const clientApiSelectProps = {
  apiParams: {
    type: Object,
    default: () => ({}),
  }
}

export type ClientApiSelectProps = Partial<ExtractPropTypes<typeof clientApiSelectProps>> & SelectProps